/**
 * Key for tracking general form errors that are not tied to a specific field.
 */
export const FORM_GENERAL_ERRORS_KEY = '_general_';
